<template>
  <v-card flat="" outlined="">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        @click="download"
        download="responses.csv"
        depressed=""
        color="green"
        :loading="isDownloading"
        :disabled="isDownloading"
        class="white--text"
      >
        <v-icon class="">mdi-download</v-icon
        ><span class="hidden-sm-and-down pl-2">Download All</span></v-btn
      >
    </v-card-title>
    <v-data-table
      :headers="headers"
      :loading="isLoading || fetchCount != days.length"
      :items="days"
      :search="search"
      sort-by="totalResponses"
      :sort-desc="true"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="footerProps"
    >
      <!-- <template v-slot:item.totalResponses="{ item }">
        {{ responses[item._id] || "N/A" }}
      </template> -->

      <template v-slot:item.action="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <!-- eslint-disable-next-line vue/valid-v-on -->
            <v-icon small v-on="on" class="" @click="showResponses(item)">
              mdi-eye
            </v-icon>
          </template>
          <span>View Responses</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import services from "@/services/index.js";
export default {
  props: ["course"],
  data() {
    return {
      isDownloading: false,
      search: "",
      isLoading: false,
      fetchCount: 0,
      days: [],
      responseCounts: {},
      headers: [
        {
          text: "Day",
          align: "left",
          sortable: true,
          value: "day",
          width: "10%"
        },
        {
          text: "Subject",
          align: "left",
          sortable: true,
          value: "subject",
          width: "50%"
        },
        { text: "Responses", value: "totalResponses" },
        { text: "Actions", value: "action", align: "right", sortable: false }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 60,
      footerProps: {
        "items-per-page-options": [10, 20, 30, 40, 50, 60]
      }
    };
  },
  computed: {
    responses() {
      return this.responseCounts;
    }
  },
  watch: {
    course() {
      this.onLoad();
    }
  },
  methods: {
    // async getStuff() {
    //   return 100;
    // },
    showResponses(item) {
      console.log("Going to ", item._id);
      this.$router.push({
        name: "responsesbyday",
        params: { courseid: this.course._id, dayid: item._id }
      });
    },
    async download() {
      this.isDownloading = true;
      try {
        window.analytics.track("Responses Downloaded");
      } catch (err) {
        console.error(err);
      }
      try {
        const blob = await services.analytics.responses.download({
          courseid: this.course._id
        });
        const url = window.URL.createObjectURL(blob);
        console.log(url);
        const link = document.createElement("a");
        link.href = url;
        const safename = `${
          this.course && this.course.name ? this.course.name : ""
        }`
          .trim()
          .replace(/[^a-z0-9]/gi, "")
          .substring(0, 30);
        const fileName = `${safename}_responses.csv`; // whatever your file name .
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove(); // you need to remove that elelment which is created before.
      } catch (err) {
        console.error("error", err);
      }
      this.isDownloading = false;
    },
    async onLoad() {
      if (this.course == null || this.course._id == null) {
        console.log("No course id");
        return;
      }
      this.isLoading = true;
      // let course = await services.course.getOne({
      //   id: this.course._id,
      //   type: "publisher"
      // });
      let days = await services.day.get({
        id: this.course._id,
        type: "publisher"
      });

      this.days = days.map(day => ({ ...day, totalResponses: Number.NaN }));
      this.days.forEach(async day => {
        try {
          let data = await services.analytics.responses.getCountByCourse({
            courseid: this.course._id,
            dayid: day._id
          });
          day.totalResponses = data.total;
        } catch (err) {
          console.error(err);
          day.totalResponses = Number.NaN;
        }
        this.fetchCount++;
      });
      this.isLoading = false;
    }
  },
  created() {
    this.onLoad();
  }
};
</script>
